const SITE = 'https://jesssellseastcoast.com';

export const sellerSeoMeta = (area, slug) => {
  const path = slug ? `/sell/${slug}` : '/home-value';
  if (!area) return { path, title: '', description: '' };
  const defaultTitle = area.custom
    ? `Sell Your ${area.name} Home | Free Home Valuation – Jess Sells East Coast`
    : `What's Your ${area.name} Home Worth? | Free Home Value Report – Jessica Burnette REALTOR®`;
  const defaultDescription = `${area.name} home values have shifted this year. Get a free, no-pressure home value report from Jessica Burnette, top REALTOR® for ${area.region}. No strings, just the number.`;
  return {
    path,
    title: area.custom?.seo?.title || defaultTitle,
    description: area.custom?.seo?.description || defaultDescription,
  };
};

export const buildSellerJsonLd = (area, faqs, { path, title, description }) => {
  const faqPage = {
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
  };
  if (!area.custom) return { '@context': 'https://schema.org', ...faqPage };
  const webPage = {
    '@type': 'WebPage',
    name: title,
    description,
    url: `${SITE}${path}`,
    about: (area.custom.neighborhoods || []).map((n) => ({ '@type': 'Place', name: `${n.name}, ${area.city}, ${area.state} ${area.name}` })),
    author: { '@type': 'Person', name: 'Jessica Burnette', url: SITE },
  };
  return { '@context': 'https://schema.org', '@graph': [webPage, faqPage] };
};
